import { selectLine, selectLogo, selectSpecial } from 'config';

export const LINE_TYPE_MNEMONIC = {
    MAIN_LANDSCAPE: selectLine[0].text,
    MAIN_PORTRAIT : selectLine[1].text,
    FULL          : selectLine[2].text
};

export const LOGO_TYPE_MNEMONIC = {
    LIGA                  : selectLogo[0].text,
    OSCARYARD_RUBLEVKA    : selectLogo[1].text,
    OSCARYARD_PUSHKINSKAYA: selectLogo[2].text,
    OSCARYARD_KOSMOS      : selectLogo[3].text,
    WITHOUT               : selectLogo[4].text
};

export const SELECT_SPECIAL = {
    ALL_SPORTS: selectSpecial[0].text,
    POPULAR   : selectSpecial[1].text,
    SEARCH_ID : selectSpecial[2].text
};



// WEBPACK FOOTER //
// ./src/pages/home/types.js